/*
 * This file is part of glowingblue/orell-bookshelf.
 *
 * Copyright (c) 2021 Priska Wermelinger & Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import Component, { type ComponentAttrs } from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import avatar from 'flarum/common/helpers/avatar';
import username from 'flarum/common/helpers/username';
import type Mithril from 'mithril';
import type Bookshelf from '../../common/models/Bookshelf';
import BookshelfArticleCount from './BookshelfArticleCount';
import BookshelfPrivacyLabel from './BookshelfPrivacyLabel';

export interface BookshelvesListItemAttrs extends ComponentAttrs {
	bookshelf: Bookshelf;
	showUser?: boolean;
}

export default class BookshelvesListItem<CustomAttrs extends BookshelvesListItemAttrs = BookshelvesListItemAttrs> extends Component<CustomAttrs> {
	view(): Mithril.Children {
		const { bookshelf, showUser } = this.attrs;

		const coverArticles = bookshelf.coverArticles();

		return (
			<div className="BookshelvesListItem">
				<div className="BookshelvesListItem-container">
					<Link href={app.route.book_collection(bookshelf)} className="BookshelvesListItem-link">
						<div className="BookshelvesListItem-cover-container">
							<div className="BookshelvesListItem-cover">
								{coverArticles &&
									coverArticles.map((article) => (
										<div className="BookshelvesListItem-cover-article">
											<img src={article?.coverImage()} />
										</div>
									))}
							</div>
						</div>
						<div className="BookshelvesListItem-details">
							<div className="BookshelvesListItem-details-name">{bookshelf.name()}</div>
							<BookshelfArticleCount bookshelf={bookshelf} />
							<BookshelfPrivacyLabel bookshelf={bookshelf} />
							{showUser && (
								<div className="BookshelvesListItem-details-user">
									{avatar(bookshelf.user() || null)}
									{username(bookshelf.user())}
								</div>
							)}
						</div>
					</Link>
				</div>
			</div>
		);
	}
}
